import React, { Fragment } from 'react'
import { css } from '@linaria/core'
import { Link } from '@fs/zion-router'
import { FlowGrid, colors, Separator, Paragraph, Skeleton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useCanAddPersonalData } from '@fs/zion-permissions'
import AppBtns from './AppBtns'
import { useDynamicLinkContext } from '../../DynamicLinksProvider'
import { buildUrl } from '../../footerHelperFunctions'

// css loaded in different order on app. !important to override this.
const linkCss = css`
  display: inline-block;
  padding: 0px !important;
  color: ${colors.transparent.gray70} !important;
  font-size: 12px !important;
  height: 24px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`

const newCss = css`
  font-size: 12px;
  color: ${colors.green60};
`

const listCss = css`
  list-style: none; // Removes the bullet points
  padding: 0;
  margin: 0;
`
const listItemCss = css`
  margin-inline-start: 0;
  padding-inline-start: 0;
`

export default function FullNavLinks({ nonReligiousMode, hideAppBtns = false, external }) {
  const [t] = useTranslation()
  const [isAuthorized] = useCanAddPersonalData()
  const { navigation } = useDynamicLinkContext()

  return (
    <>
      <FlowGrid columnCount={4} gutters="sm" guttersY="sm" orientation="vertical" lastRowAlignX="start">
        {navigation?.footer?.map(
          (section) =>
            !section.hidden && (
              <Fragment key={section.id}>
                <Paragraph size="sm" as="strong">
                  {section.title || section.text}
                </Paragraph>
                <Separator size="nano" />
                <ul className={listCss} aria-label={section.title}>
                  {(section.subNav || section.sub).map(
                    ({ text, hidden, id, url, isNew, dataTestId, ...linkProps }) =>
                      !hidden && (
                        <li key={id} className={listItemCss}>
                          <Link
                            to={buildUrl(url, external)}
                            className={linkCss}
                            data-test-id={dataTestId}
                            noLinkStyles
                            external
                            wayfinding
                            {...linkProps}
                          >
                            {isNew ? (
                              <>
                                {text} <span className={newCss}>{t('FooterExpansionContent.new.label', 'NEW')}</span>
                              </>
                            ) : (
                              <> {text}</>
                            )}
                          </Link>
                        </li>
                      )
                  )}
                </ul>
              </Fragment>
            )
        ) ||
          [1, 2, 3, 4, 5, 6, 7].map((id) => (
            <Fragment key={id}>
              <Skeleton.Paragraph />
              <Skeleton.Paragraph maxWidth={120} />
              <Skeleton.Paragraph maxWidth={120} />
              <Skeleton.Paragraph maxWidth={120} />
            </Fragment>
          ))}
      </FlowGrid>
      {!hideAppBtns && <Separator size="sm" />}
      {nonReligiousMode || !isAuthorized || hideAppBtns ? null : <AppBtns />}
    </>
  )
}
